import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["toTakeAway", "href", "alwaysA", "isAnchorOffcanvas", "onClick", "preventLink"];
import React from "react";
import { Link } from "react-router-dom";
import { isOrderActive, isMiscusiMainActive } from "./miScusiAndTakeAwayUtils";
import { env } from "build/env";
export var LinkBetween = _ref => {
  var {
      toTakeAway,
      href,
      alwaysA,
      isAnchorOffcanvas,
      onClick,
      preventLink = false
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var toMiScusi = !toTakeAway;
  if (onClick && preventLink) {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: "#",
      onClick: onClick
    }, props));
  }
  if (isAnchorOffcanvas) {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: "".concat(href),
      "data-uk-toggle": ""
    }, props));
  }
  if (alwaysA) {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: href
    }, props));
  }
  if (isOrderActive && toTakeAway || isMiscusiMainActive && toMiScusi) {
    return /*#__PURE__*/React.createElement(Link, _extends({
      to: href
    }, props));
  }
  if (!isOrderActive && toTakeAway) {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: "".concat(window.location.protocol, "//").concat(env.URL_TAKEAWAY).concat(href)
    }, props));
  }
  if (!isMiscusiMainActive && toMiScusi) {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: "".concat(window.location.protocol, "//").concat(env.URL_MISCUSI).concat(href)
    }, props));
  }
  throw new Error("not found");
};
LinkBetween.defaultProps = {
  toTakeAway: false
};
export default LinkBetween;